import { render, staticRenderFns } from "./SocialsRibbonSection.vue?vue&type=template&id=63c5381f&scoped=true&lang=pug"
import script from "./SocialsRibbonSection.vue?vue&type=script&lang=js"
export * from "./SocialsRibbonSection.vue?vue&type=script&lang=js"
import style0 from "./SocialsRibbonSection.styl?vue&type=style&index=0&id=63c5381f&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5381f",
  null
  
)

export default component.exports